import request from '../../axios';
import {AxiosRequestConfig} from 'axios';

export const searchThroughAll = async (
  pageNumber: number,
  params: ISearchThroghAllParams,
) => {
  const {data}: {data: ISearchThroughAllData} = await request.get(
    `api/v2/store/search-through-all`,
    {
      params: {...params, page: pageNumber},
    } as AxiosRequestConfig,
  );
  return data;
};

export const searchThroughInputs = async (
  params: ISearchThroughInputParams,
) => {
  const {data}: {data: ISearchThrough} = await request.get(
    `api/v2/store/search-through-inputs`,
    {
      params: params,
    } as AxiosRequestConfig,
  );
  return data;
};
